/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Html from './Html';

import styles from '../../../styles/partials/project-award.module.scss';

const propTypes = {
    name: PropTypes.string,
    summary: PropTypes.string,
    description: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    name: null,
    summary: null,
    description: null,
    className: null,
};

const ProjectAward = ({ name, summary, description, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div className={styles.group}>
            {name !== null ? <h4 className={styles.name}>{name}</h4> : null}
            {summary !== null ? <p className={styles.summary}>{summary}</p> : null}
        </div>
        {description !== null ? <Html className={styles.description} body={description} /> : null}
    </div>
);
ProjectAward.propTypes = propTypes;
ProjectAward.defaultProps = defaultProps;

export default ProjectAward;
